import FollowUpVisit from "./FollowUpVisit"

export default FollowUpVisit
